import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter } from "@angular/router";
import { provideStore } from "@ngrx/store";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { AuthInterceptor } from "./interceptors/auth.interceptor";
import { ErrorInterceptor } from "./interceptors/error.interceptor";
import { WorkspaceInterceptor } from "./interceptors/workspace.interceptor";
import { TokenRefreshService } from "./services/token-refresh.service";
import { TOKEN_REFRESH_SERVICE } from "./tokens/token-refresh.token";

import { routes } from "./app.routes";
import { provideRuntimeConfigInitializer } from "./core/initializers/runtime-config.initializer";
import { indexReducer } from "./store/index.reducer";
import { AppService } from "./services/app.service";
import { provideHotToastConfig } from "@ngxpert/hot-toast";
import { provideFlatpickrDefaults } from "angularx-flatpickr";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: provideRuntimeConfigInitializer,
      multi: true,
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideHotToastConfig(),
    provideHttpClient(withInterceptorsFromDi()),
    provideStore({ index: indexReducer }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: WorkspaceInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: TOKEN_REFRESH_SERVICE,
      useExisting: TokenRefreshService,
    },
    AppService,
    ...provideFlatpickrDefaults(),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: "en",
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
  ],
};
